module.exports = __webpack_public_path__ + "static/media/slide07.0e062e5e.jpg";